import React from 'react';
import MenuItem from "./MenuItem.js";
import "./Menu.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function Menu(_ref) {
  var items = _ref.items,
    _ref$onSelect = _ref.onSelect,
    _onSelect = _ref$onSelect === void 0 ? () => undefined : _ref$onSelect,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsx("div", {
    className: "navigation-menu-view",
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx("ul", {
      className: "navigation-menu-list",
      children: items.map((item, itemIndex) => /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(MenuItem, {
          item: item,
          onSelect: () => {
            _onSelect(itemIndex);
          }
        })
      }, item.title))
    })
  });
}
export default Menu;
//# sourceMappingURL=Menu.js.map